import { MESSAGE } from '@repo/constants'
import type { TFunction } from 'i18next'
import { z } from 'zod'

const errorBodySchema = z.object({ message: z.string().min(1) })

/** The `MESSAGE.*` code of an error body or thrown error, if it carries one. */
export const errorCode = (body: unknown) => errorBodySchema.safeParse(body).data?.message

/**
 * Copy for a backend `MESSAGE.*` code (`I18N-03`), keyed by the code in the
 * `auth` namespace, or `fallback` when there is no code or no copy for it.
 */
export const describeAuthError = (
  t: TFunction,
  code: string | null | undefined,
  fallback: string,
): string => (code ? t(`auth:errors.${code}`, { defaultValue: fallback }) : fallback)

/**
 * The code a refused session is signed out with, when the login screen should
 * explain it (`TEN-08`). A plain expired or revoked session needs no words.
 */
export const signOutReason = (code: string | null | undefined) =>
  code === MESSAGE.TENANT_INACTIVE ? code : undefined
